// extracted by mini-css-extract-plugin
export default {"productDescription":"O--z","featuredDescription":"P--z","description":"Q--z","more":"R--z","descriptionSku":"S--z"};